(ns minorodata.health.api
  (:require [mold-http.core :refer [reg-event-http]]
            [re-frame.core :as re-frame]))


(defn fetch-dashboard-url
  [_ [id base-url {:keys [hide-menu]}]]
  {:http-xhrio
   {:url (str "/api/dashboards/embed-url-jwt")
    :params {:sigma-url base-url
             :hide-menu hide-menu}
    :cb-params {:id       id
                :base-url base-url}}})

(defn fetch-dashboard-userbacked-url
  [_ [id base-url {:keys [hide-menu workbook]}]]
  {:http-xhrio
   {:url (str "/api/dashboards/embed-userbacked-url-jwt")
    :params {:sigma-url base-url
             :hide-menu hide-menu
             :workbook  workbook}
    :cb-params {:id       id
                :base-url base-url}}})

(defn fetch-dashboard-url-callback
  [_ [error resp {:keys [id]}]]
  (if (some? error)
    {:dispatch-n [[:app.events/add-snack :error "Failed to load the dashboard"]
                  [:app.api/log :error "Failed to load the dashboard URL" error]
                  [:health.events/set-dashboard-url id nil :failure]]}
    {:dispatch [:health.events/set-dashboard-url id (:sigma-embed-url resp) :success]}))

(reg-event-http
  :health.api/fetch-dashboard-url
  fetch-dashboard-url
  fetch-dashboard-url-callback)

(reg-event-http
  :health.api/fetch-dashboard-userbacked-url
  fetch-dashboard-userbacked-url
  fetch-dashboard-url-callback)


;; Sigma connection id menagement

(defn fetch-sigma-connection-info
  [_ [cid]]
  {:http-xhrio
   {:url "/api/app-admin/sigma/sigma-connection-id"
    :params {:cid cid}}})


(defn fetch-sigma-connection-info-callback
  [_ [error resp]]
  (if (and (some? error)
           (not (nil? (:response error))))
    {:dispatch [:app.events/add-snack :error "Failed to load sigma connection info"]}
    {:dispatch [:health.db/set-sigma-connection-info resp]}))

(reg-event-http
  :health.api/fetch-sigma-connection-info
  fetch-sigma-connection-info
  fetch-sigma-connection-info-callback)

(re-frame/reg-event-db
 :health.db/set-sigma-connection-info
 (fn [db [_ resp]]
   (let [client-id (:client-id resp)
         sigma-id  (:sigma-connection-id resp)]
     (assoc-in db [:sigma-connection-ids client-id] sigma-id))))

(re-frame/reg-sub
 :health/get-sigma-connection-by-client-id
 (fn [db [_ client-id]]
   (get-in db [:sigma-connection-ids client-id] "")))

(defn update-sigma-connection-info
  [_ [cid sid]]
  {:http-xhrio
   {:url    "/api/app-admin/sigma/sigma-connection-id"
    :method :post
    :params {:cid cid
             :sid sid}}})

(defn update-sigma-connection-info-callback
  [_ [error resp]]
  (if (and (some? error)
           (not (nil? (:response error))))
    {:dispatch [:app.events/add-snack :error "Failed to update sigma connection info"]}
    {:dispatch-n [[:app.events/add-snack :success "Sigma connection info updated"]
                  [:health.db/set-sigma-connection-info resp]]}))

(reg-event-http
  :health.api/update-sigma-connection-info
  update-sigma-connection-info
  update-sigma-connection-info-callback)


;; Sigma details management
;; sigma-{user-id, email, teams, workbook-url}

(defn fetch-sigma-details
  [_ [client-id]]
  {:http-xhrio
   {:url "/api/app-admin/sigma/sigma-details"
    :params {:client-id client-id}}})


(defn fetch-sigma-details-callback
  [_ [error resp]]
  (if (and (some? error)
           (not (nil? (:response error))))
    {:dispatch [:app.events/add-snack :error "Failed to load sigma details"]}
    {:dispatch [:health.db/set-sigma-details resp]}))

(reg-event-http
  :health.api/fetch-sigma-details
  fetch-sigma-details
  fetch-sigma-details-callback)

(re-frame/reg-event-db
 :health.db/set-sigma-details
 (fn [db [_ resp]]
   (let [client-id (:client-id resp)]
     (assoc-in db [:sigma-details client-id] resp))))

(re-frame/reg-sub
 :health/get-sigma-details-by-client-id
 (fn [db [_ client-id]]
   (get-in db [:sigma-details client-id] {})))

(defn update-sigma-details
  [_ [params]]
  {:http-xhrio
   {:url    "/api/app-admin/sigma/sigma-details"
    :method :post
    :params params}})

(defn update-sigma-details-callback
  [_ [error resp]]
  (if (or error
          (>= (:status resp) 400))
    {:dispatch [:app.events/add-snack :error "Failed to update sigma details"]}
    {:dispatch-n [[:app.events/add-snack :success "Sigma details updated"]
                  [:health.db/set-sigma-details resp]]}))

(reg-event-http
  :health.api/update-sigma-details
  update-sigma-details
  update-sigma-details-callback)
